module.exports = __webpack_public_path__ + "static/media/logo-dark.4a799e5b.png";